<div v-click-away="clickaway"><search-box-input></search-box-input><search-box-results class="w-full"></search-box-results></div>